export const BASE_URL = process.env.VUE_APP_BASE_WEB_URL
export const BASE_URL_NEW = process.env.VUE_APP_LB_URL
export const VUE_APP_URL = process.env.VUE_APP_BASE_URL
export const CM_BASE_URL = process.env.VUE_APP_CM_BASE_URL
export const SALESGEAR_URL = process.env.VUE_APP_SALESGEAR_URL

export const SF_API_ID = process.env.VUE_APP_SF_API_ID
export const GOOGLE_SIGN_UP_KEY = {
  client_id: process.env.VUE_APP_GOOGLE_AUTH_KEY_CLIENT_ID,
  scope: process.env.VUE_APP_GOOGLE_AUTH_KEY_SCOPE,
  api_key: process.env.VUE_APP_GOOGLE_AUTH_KEY_API_KEY
}
export const GOOGLE_CAPTCHA_SITE_KEY = process.env.VUE_APP_RECAPTCHA_KEY

export const SALESGEAR = 'Salesgear'
export let AE_PRODUCT_BASE_URL = 'https://www.adapt.io/products/engage'

export const SF_LOGIN_PAGE =
  'https://login.salesforce.com/services/oauth2/authorize?response_type=code&client_id='

export const SF_CALL_BACK_URL = `${BASE_URL}/oauth2/salesforce/callback.htm`
export const SF_LOGIN_POPUP_METHOD = 'salesforcePopup'

export const LI_PARSER_ERROR = {
  SINGLE: 'li-single-parser-err',
  BULK: 'li-bulk-parser-err',
  COMPANY: 'li-company-err'
}

export function advanceSearchUrl(companyDomain, uiVersion, triggerPlace) {
  if (uiVersion === undefined || uiVersion === 'A')
    return (
      BASE_URL +
      '/advancedSearchResults.htm?companyDomain=' +
      companyDomain +
      '&showAll=true'
    )
  else
    return (
      BASE_URL_NEW +
      '/advanced-search/contact?companyDomain=' +
      companyDomain +
      '&trigger=' +
      triggerPlace
    )
}

export function myLeadsUrl(listId, triggerPlace) {
  return `${BASE_URL_NEW}/my-leads/${listId}?trigger=${triggerPlace}`
}

export const TRIGGERS_TRACK_TO_LB = {
  VIEW_LIST: 'view-list',
  EXPORT_CONTACT: 'export-contact',
  SINGLE_VIEW_CONTACTS: 'single-view-contacts',
  WEBSITE_VIEW_CONTACTS: 'website-view-contacts'
}

export const PAGE_URL = {
  ONBOARDING: '/start'
}

export const URLS = {
  registerUser: 'li/registerUser.htm',
  forgotPassword: 'li/forgotPasswordUser.htm',
  loginUser: 'j_spring_security_check',
  connectWithGoogle: 'li/signInWithGoogle.htm',
  domChangeAlert: 'lp/domchange.htm'
}

export const HP_DOMAIN_URL = 'hpe.com'

export const TOKENS_VARIABLE = [
  {
    key: 'firstName',
    value: '{{firstName}}',
    name: 'John',
    text: 'First Name'
  },
  { key: 'lastName', value: '{{lastName}}', name: 'Smith', text: 'Last Name' },
  {
    key: 'companyName',
    value: '{{companyName}}',
    name: 'Microsoft',
    text: 'Company'
  },
  {
    key: 'jobTitle',
    value: '{{jobTitle}}',
    name: 'VP of Sales',
    text: 'Title'
  },
  {
    key: 'industry',
    value: '{{industry}}',
    name: 'Software & Internet',
    text: 'Industry'
  },
  { key: 'city', value: '{{city}}', name: 'Seattle', text: 'City' },
  { key: 'state', value: '{{state}}', name: 'Washington', text: 'State' },
  { key: 'country', value: '{{country}}', name: 'USA', text: 'Country' },
  {
    key: 'phoneNumber',
    value: '{{phoneNumber}}',
    name: '800-285-7772',
    text: 'Phone Number'
  },
  {
    key: 'mobileNumber',
    value: '{{mobileNumber}}',
    name: '425-706-4400',
    text: 'Mobile Number'
  },
  {
    key: 'website',
    value: '{{website}}',
    name: 'www.microsoft.com',
    text: 'Website'
  },
  {
    key: 'customField1',
    value: '{{customField1}}',
    name: '{{customField1}}',
    text: 'Custom Field 1'
  },
  {
    key: 'customField2',
    value: '{{customField2}}',
    name: '{{customField2}}',
    text: 'Custom Field 2'
  },
  {
    key: 'customField3',
    value: '{{customField3}}',
    name: '{{customField3}}',
    text: 'Custom Field 3'
  },
  {
    key: 'customField4',
    value: '{{customField4}}',
    name: '{{customField4}}',
    text: 'Custom Field 4'
  },
  {
    key: 'customField5',
    value: '{{customField5}}',
    name: '{{customField5}}',
    text: 'Custom Field 5'
  },
  {
    key: 'customField6',
    value: '{{customField6}}',
    name: '{{customField6}}',
    text: 'Custom Field 6'
  },
  {
    key: 'customField7',
    value: '{{customField7}}',
    name: '{{customField7}}',
    text: 'Custom Field 7'
  },
  {
    key: 'customField8',
    value: '{{customField8}}',
    name: '{{customField8}}',
    text: 'Custom Field 8'
  },
  {
    key: 'customField9',
    value: '{{customField9}}',
    name: '{{customField9}}',
    text: 'Custom Field 9'
  },
  {
    key: 'customField10',
    value: '{{customField10}}',
    name: '{{customField10}}',
    text: 'Custom Field 10'
  },
  {
    key: 'customField11',
    value: '{{customField11}}',
    name: '{{customField11}}',
    text: 'Custom Field 11'
  },
  {
    key: 'customField12',
    value: '{{customField12}}',
    name: '{{customField12}}',
    text: 'Custom Field 12'
  },
  {
    key: 'customField13',
    value: '{{customField13}}',
    name: '{{customField13}}',
    text: 'Custom Field 13'
  },
  {
    key: 'customField14',
    value: '{{customField14}}',
    name: '{{customField14}}',
    text: 'Custom Field 14'
  },
  {
    key: 'customField15',
    value: '{{customField15}}',
    name: '{{customField15}}',
    text: 'Custom Field 15'
  },
  {
    key: 'customField16',
    value: '{{customField16}}',
    name: '{{customField16}}',
    text: 'Custom Field 16'
  }
]
export const PLUGIN_DOWNLOAD_URL =
  'https://chrome.google.com/webstore/detail/free-email-tracker/nbmmhcmajjdfjobnmgnkbdhfpnbhpkef'

export const G2_REVIEW_LINK =
  'https://www.g2.com/products/adapt-adapt/reviews#reviews'
